import { useEffect, useRef, useState } from 'react';

export type InfiniteType = 'dlcenter' | 'footer' | 'partner-tech';

const map = new Map<InfiniteType, Set<() => void>>();

const add = (id: InfiniteType, callback: () => void) => {
  if (!map.has(id)) {
    map.set(id, new Set());
  }
  map.get(id)?.add(callback);
};
const remove = (id: InfiniteType, callback: () => void) => {
  map.get(id)?.delete(callback);
};

const notify = (id: InfiniteType) => {
  map.get(id)?.forEach((callback) => {
    callback();
  });
};

export const useInfiniteClient = (id: InfiniteType, callback: () => void) => {
  useEffect(() => {
    add(id, callback);
    return () => {
      remove(id, callback);
    };
  }, [id, callback]);
};

export const useInfiniteScroll = (id: InfiniteType, threshold: number = 1.0) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsIntersecting(entry.isIntersecting);
          if (entry.isIntersecting) {
            notify(id);
          }
        });
      },
      { threshold: threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref.current, id, threshold]);
  return { ref, isIntersecting };
};
